import React, { useState } from 'react';
import Modal from '../../../components/Modal/Modal';
import { useModalStore } from '../../../store/ModalStore';
import styles from './TasksModal.module.css';
// import {
//   CheckSubscriptionButton,
//   HideTaskButton,
//   SubscribeButton,
// } from './TaskModalButtons';
import Reward from '../../../components/Reward/Reward';

// import {
//   addTaskToBlacklist,
//   getTaskTgLink,
//   postPartnerTasks,
// } from '../../Services/Requests';

import { SponsorsService } from '../PartnerTasks/PartnerTasksService';
import SubscribeButton from './SubscribeButton';
import CheckSubscriptionButton from './CheckSubscriptionButton';

// interface ClaimResponse {
//   task_id: number | string;
//   status: string;
//   rewards_processed?: unknown[];
// }

export const TaskModal: React.FC = () => {
  const currentTask = useModalStore((state) => state.currentTask);
  console.log('currentTask', currentTask);
  const setClosing = useModalStore((state) => state.setClosing);

  //   const setNotification = useNotificationStore(
  //     (state) => state.setNotification,
  //   );
  const [taskStatus, setTaskStatus] = useState(
    currentTask?.status ?? 'NOT_STARTED',
  );
  const isLocked = false;

  // Функция для рендеринга всех наград
  const renderRewards = () => {
    if (!currentTask?.rewards) return null;

    const rewards = [];

    rewards.push(<Reward reward={currentTask.rewards.beastcoins ?? 0} />);

    return rewards.length > 0 ? rewards : null;
  };

  const isTaskCompleted = currentTask?.status === 'DONE';
  const tg = window.Telegram?.WebApp;
  const handleSubscribe = async () => {
    if (!currentTask) return;

    switch (currentTask.provider) {
      case 'SUBGRAM':
        if (currentTask.link) {
          if (currentTask.link.startsWith('https://t.me/')) {
            tg?.openTelegramLink(currentTask.link);
          } else {
            tg?.openLink(currentTask.link);
          }
        }
        break;
      case 'FLYER':
        if (currentTask.link) {
          if (currentTask.link.startsWith('https://t.me/')) {
            tg?.openTelegramLink(currentTask.link);
          } else {
            tg?.openLink(currentTask.link);
          }
        }
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    setClosing(true);
  };

  const handleCheckSubscription = async () => {
    if (!currentTask) return;

    try {
      const taskId = ['FLYER', 'TRAFFY', 'SUBGRAM', 'TADDY'].includes(
        currentTask.provider,
      )
        ? currentTask.id
        : Number(currentTask.id);

      const response = await SponsorsService.claimSponsorTask(taskId);
      console.log('responseEEEEE', response);

      // Проверяем новый формат ответа
      if (typeof response === 'object' && response?.completed) {
        setTaskStatus('CLAIMED');
        // Уведомляем родительский компонент об обновлении
        window.dispatchEvent(
          new CustomEvent('taskCompleted', {
            detail: { taskId: currentTask.id },
          }),
        );
        handleClose();
      } else if (
        typeof response === 'object' &&
        'status' in response &&
        response.status === 'CLAIMED'
      ) {
        setTaskStatus('CLAIMED');
        handleClose();
      } else {
        handleClose();
      }
    } catch (error) {
      console.error('Ошибка при получении награды:', error);
      handleClose();
    }
  };

  // const handleTaskHiding = async () => {
  //   const tg = window.Telegram?.WebApp;
  //   tg?.showConfirm(
  //     'Вы точно хотите скрыть задание? Это действие нельзя будет отменить.',
  //     async (confirmed: boolean) => {
  //       if (confirmed) {
  //         //   const resData = await addTaskToBlacklist(currentTask);

  //         //   if (resData.error) {
  //         //     console.log(
  //         //       '❌ Error putting task to blacklist ==>',
  //         //       resData.error,
  //         //     );
  //         //     setNotification({
  //         //       type: 'Error',
  //         //       message: 'Ошибка при скрытии задания. Попробуйте позже.',
  //         //     });

  //         //     return;
  //         //   } else {
  //         //     setTasks(tasks.filter((task) => task.id !== currentTask?.id));
  //         //     setNotification({
  //         //       type: 'Success',
  //         //       message: 'Задание скрыто',
  //         //     });
  //         //     setClosing(true);
  //         //   }
  //         console.log('confirmed');
  //       }
  //     },
  //   );
  // };

  if (!currentTask) return null;

  return (
    <Modal>
      <div className={styles.taskModal}>
        {(currentTask.provider === 'FLYER' ||
          currentTask.provider === 'DREAMCOIN_SUBSCRIBE' ||
          currentTask.provider === 'DREAMCOIN_CLICK') && (
            //   <HideTaskButton onClick={handleTaskHiding} task={currentTask} />
            <></>
          )}
        <div className={styles.taskHeader}>
          {' '}
          <div className={styles.taskIconContainer}>
            {currentTask.icon === '' || !currentTask.icon.includes('http') ? (
              <div className={styles.noTaskIcon}>
                {(() => {
                  // Регулярное выражение для проверки эмодзи
                  const emojiRegex =
                    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

                  // Проверяем, содержит ли заголовок эмодзи
                  if (emojiRegex.test(currentTask.title)) {
                    // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
                    return currentTask.title.slice(1, 2);
                  } else {
                    // Если нет эмодзи, берем первую букву
                    return currentTask.title.slice(0, 1);
                  }
                })()}
              </div>
            ) : (
              <>
                <img
                  src={currentTask.icon}
                  alt={currentTask.title}
                  className={styles.taskIcon}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    const nextElement = e.currentTarget
                      .nextElementSibling as HTMLElement;
                    if (nextElement) {
                      nextElement.style.display = 'flex';
                    }
                  }}
                />
                <div className={styles.noTaskIcon} style={{ display: 'none' }}>
                  {(() => {
                    // Регулярное выражение для проверки эмодзи
                    const emojiRegex =
                      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

                    // Проверяем, содержит ли заголовок эмодзи
                    if (emojiRegex.test(currentTask.title)) {
                      // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
                      return currentTask.title.slice(1, 2);
                    } else {
                      // Если нет эмодзи, берем первую букву
                      return currentTask.title.slice(0, 1);
                    }
                  })()}
                </div>
              </>
            )}
          </div>
          <div>
            {/* <div className={styles.taskId}>
              ID:{' '}
              {typeof currentTask.id === 'string'
                ? currentTask.id.substring(0, 40)
                : currentTask.id}
            </div> */}
          </div>
          {/* {(() => {
            switch (currentTask.provider) {
              case 'PARTNERS':
              case 'BARZHA':
              case 'DREAMCOIN_SUBSCRIBE':
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
              case 'BARZHA_CLICK':
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
              case 'TAPPADS':
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
              case 'FLYER':
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
              case 'DAILY':
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
              default:
                return <p className={styles.taskTitle}>{currentTask.title}</p>;
            }
          })()} */}
          <div className={styles.taskInfoHead}>
            Подпишись на канал
          </div>
        </div>
        <div className={styles.taskInfoContainer}>
          {(() => {
            switch (currentTask.provider) {
              case 'BARZHA':
                return (
                  <>
                    <div className={styles.taskInfo}>{renderRewards()}</div>
                    <div className={styles.task_instructions}>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{1}</div>
                        <div className={styles.instructionText}>
                          Нажми «Подписаться» внизу экрана.
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{2}</div>
                        <div className={styles.instructionText}>
                          Подпишись на канал
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{3}</div>
                        <div className={styles.instructionText}>
                          Вернись сюда, нажми на кнопку “Проверить задание”
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{4}</div>
                        <div className={styles.instructionText}>
                          Получи свою награду
                        </div>
                      </div>
                      {/* <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{5}</div>
                        <div>
                          {' '}
                          Останься подписан(а) на 7 дней <br /> и получи бонус{' '}
                          {<Reward reward={50} />}
                        </div>
                      </div> */}
                    </div>
                  </>
                );
              case 'TAPPADS':
                return (
                  <>
                    <div className={styles.taskInfo}>{renderRewards()}</div>
                    <div className={styles.task_instructions}>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{1}</div>
                        <div className={styles.instructionText}>
                          Нажми «Подписаться» внизу экрана.
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{2}</div>
                        <div className={styles.instructionText}>
                          Подпишись на канал
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{3}</div>
                        <div className={styles.instructionText}>
                          Вернись сюда, нажми на кнопку “Проверить задание”
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{4}</div>
                        <div className={styles.instructionText}>
                          Получи свою награду
                        </div>
                      </div>
                    </div>
                  </>
                );
              case 'FLYER':
                return (
                  <>
                    <div className={styles.taskInfo}>{renderRewards()}</div>
                    <div className={styles.task_instructions}>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{1}</div>
                        <div className={styles.instructionText}>
                          Нажми «Подписаться» внизу экрана.
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{2}</div>
                        <div className={styles.instructionText}>
                          Подпишись на канал
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{3}</div>
                        <div className={styles.instructionText}>
                          Вернись сюда, нажми на кнопку “Проверить задание”
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{4}</div>
                        <div className={styles.instructionText}>
                          Получи свою награду
                        </div>
                      </div>
                    </div>
                  </>
                );

              case 'SUBGRAM':
                return (
                  <>
                    <div className={styles.taskInfo}>{renderRewards()}</div>
                    <div className={styles.task_instructions}>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{1}</div>
                        <div className={styles.instructionText}>
                          Нажми «Подписаться» внизу экрана.
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{2}</div>
                        <div className={styles.instructionText}>
                          Подпишись на канал
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{3}</div>
                        <div className={styles.instructionText}>
                          Вернись сюда, нажми на кнопку “Проверить задание”
                        </div>
                      </div>
                      <div className={styles.task_instructionItem}>
                        <div className={styles.instructionNumber}>{4}</div>
                        <div className={styles.instructionText}>
                          Получи свою награду
                        </div>
                      </div>
                    </div>
                  </>
                );
              default:
                return null;
            }
          })()}
        </div>
        {/* <div className={styles.taskLine}></div> */}
        <div className={styles.buttons}>
          {currentTask.status !== 'DONE' && (
            <SubscribeButton onClick={handleSubscribe} isLocked={isLocked} />
          )}
          <CheckSubscriptionButton
            onClick={handleCheckSubscription}
            isLocked={isLocked}
            completed={isTaskCompleted}
            task={{ ...currentTask, status: taskStatus }}
          />
        </div>
      </div>
    </Modal>
  );
};
